<template>
  <v-card title="Information">
    <template v-slot:append>
      <v-icon icon="mdi-pencil" @click="isBranchYearEdit = !isBranchYearEdit">
        <v-tooltip activator="parent" location="end">Edit Branch Info</v-tooltip>
      </v-icon>
    </template>
    <v-card-text v-if="!isBranchYearEdit">
      <v-row>
        <v-col cols="12" md="6"> Max Teams: </v-col>
        <v-col cols="12" md="6">
          {{ (branchYear.max_teams ?? 0) >= 0 ? branchYear.max_teams : 'Unlimited' }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6"> Launch Location: </v-col>
        <v-col cols="12" md="6">
          {{ branchYear.launch_location }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6"> Launch Address: </v-col>
        <v-col cols="12" md="6">
          {{ branchYear.launch_address }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6"> Who Enters Criteria: </v-col>
        <v-col cols="12" md="6">
          {{ branchYear.team_select ? 'Teams' : 'Admin' }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6"> Criteria Selection Start Time: </v-col>
        <v-col cols="12" md="6">
          {{ branchYear.displayCriteriaStartDate }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6"> Criteria Selection End Time: </v-col>
        <v-col cols="12" md="6">
          {{ branchYear.displayCriteriaEndDate }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6"> Friday Block 1 Start: </v-col>
        <v-col cols="12" md="6">
          {{ branchYear.displayFridayBlock1 }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6"> Friday Block 2 Start: </v-col>
        <v-col cols="12" md="6">
          {{ branchYear.displayFridayBlock2 }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6"> Saturday Start: </v-col>
        <v-col cols="12" md="6">
          {{ branchYear.displaySaturday }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6"> After Party Location: </v-col>
        <v-col cols="12" md="6">
          {{ branchYear.afterparty_loc }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6"> After Party Address: </v-col>
        <v-col cols="12" md="6">
          {{ branchYear.afterparty_address }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6"> After Party Start: </v-col>
        <v-col cols="12" md="6">
          {{ branchYear.displayAfterPartyTime }}
        </v-col>
      </v-row>
    </v-card-text>
    <v-form v-else ref="form">
      <v-card-text>
        <v-text-field v-model="branchYear.max_teams" label="Max Teams"></v-text-field>
        <v-text-field v-model="branchYear.launch_location" label="Launch Location"></v-text-field>
        <v-switch
          v-model="branchYear.team_select"
          :label="
            branchYear.team_select ? 'Teams enter their criteria' : 'Admins enter selected criteria'
          "></v-switch>
        <v-text-field v-model="branchYear.launch_address" label="Launch Address"></v-text-field>
        <v-text-field
          v-model="branchYear.fieldInputCriteriaStartDate"
          label="Criteria Selection Start Timet"
          type="datetime-local"></v-text-field>
        <v-text-field
          v-model="branchYear.fieldInputCriteriaEndDate"
          label="Criteria Selection End Timet"
          type="datetime-local"></v-text-field>
        <v-text-field
          v-model="branchYear.fieldInputFridayBlock1"
          label="Fridy Block 1 Start"
          type="datetime-local"></v-text-field>
        <v-text-field
          v-model="branchYear.fieldInputFridayBlock1"
          label="Fridy Block 1 Start"
          type="datetime-local"></v-text-field>
        <v-text-field
          v-model="branchYear.fieldInputFridayBlock2"
          label="Fridy Block 2 Start"
          type="datetime-local"></v-text-field>
        <v-text-field
          v-model="branchYear.fieldInputSaturday"
          abel="Saturday Start"
          type="datetime-local"></v-text-field>
        <v-text-field
          v-model="branchYear.afterparty_loc"
          label="After Party Location"></v-text-field>
        <v-text-field
          v-model="branchYear.afterparty_address"
          label="After Party Address"></v-text-field>
        <v-text-field
          v-model="branchYear.fieldInputAfterPartyTime"
          label="After Party Start"
          type="datetime-local"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn :loading="isSubmitting" color="primary" @click="onSubmit"> Save </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { BranchYearDTO, IBranchYearDTO } from '@/dtos';
import { useBranchYearStore } from '@/stores/modules/admin';
import { useUpdateStatusStore } from '@/stores/modules';
interface Props {
  branchYear: IBranchYearDTO;
}
const props = defineProps<Props>();
const emit = defineEmits(['snack']);

const branchYear = ref<IBranchYearDTO>(new BranchYearDTO());

watch(
  () => props.branchYear,
  () => {
    branchYear.value = new BranchYearDTO(props.branchYear);
  },
);
const branchYearStore = useBranchYearStore();
const statusStore = useUpdateStatusStore();
const isBranchYearEdit = ref<boolean>(false);
const isSubmitting = ref<boolean>(false);
const form = ref();

const onSubmit = async () => {
  if (form.value.isValid) {
    isSubmitting.value = true;
    branchYearStore.update.mutateAsync(branchYear.value);
  }
};

const status = computed(() => statusStore.getStatus(key.value));
const key = computed(() => `branch-year-${branchYear.value.id}`);
watch(status, (value) => {
  if (!value) return;

  if (value == 'success:create' || value == 'success:delete' || value == 'success:update') {
    isBranchYearEdit.value = false;
  }
  isSubmitting.value = false;

  emit('snack', 'Branch Year', value, statusStore.getError(key.value));
});
</script>
